import Heading from 'LuxKit/Typography/Heading'
import { useCallback } from 'react'
import { useIntl } from 'react-intl'
import { rem } from 'polished'
import useTrackExperienceOfferEvent from 'contexts/support/useTrackExperienceOfferEvent'
import CategoryTile from 'LuxKit/CategoryTile'
import CardCarousel from 'LuxKit/Carousel/CardCarousel'
import { replaceExperienceQueryString } from 'lib/experiences/experienceUtils'
import formatStaticAppText from 'lib/format/formatStaticAppText'
import type { PlaceImage } from './ExperiencesPageHardcodedLists'

interface Props {
  locations: Array<PlaceImage>
}

function ExperiencesTrendingDestinationsCarousel({ locations }: Props) {
  const intl = useIntl()
  const trackEvent = useTrackExperienceOfferEvent()

  const handleOnTileClick = useCallback(() => {
    trackEvent('TRENDING_TILE_CLICKED')
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- trackEvent is stable
  }, [])

  return <>
    <Heading variant="heading3">
      {intl.formatMessage({
        id: 'xg_2zhy5zNbfN9w044e8',
        defaultMessage: 'Immerse yourself in these trending destinations',
        description: 'Heading for the trending destinations carousel on experiences landing page',
      })}
    </Heading>
    <CardCarousel pageSize={6} width={rem(180)}>
      {locations.map(location => <CategoryTile
        to={`/search/experiences?${replaceExperienceQueryString({
          destinationId: location.place.id,
          destinationName: location.place.name,
        })}`}
        key={location.place.id}
        image={{ id: location.imageId }}
        heading={formatStaticAppText(intl, location.place.name)}
        onClick={handleOnTileClick}
        align="bottom"
      />)}
    </CardCarousel>
  </>
}

export default ExperiencesTrendingDestinationsCarousel
